var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgApplePay = function SvgApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 35,
    rx: 3.5,
    fill: "#FBFCFF",
    stroke: "#D5E3ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.162 9a3.976 3.976 0 0 1-.951 2.882 3.427 3.427 0 0 1-1.224.945 3.51 3.51 0 0 1-1.525.32 3.706 3.706 0 0 1 .203-1.482c.167-.476.43-.914.774-1.29A4.127 4.127 0 0 1 29.162 9Zm-2.451 4.882c.678-.26 1.516-.583 2.44-.53a4.424 4.424 0 0 1 1.904.522 4.312 4.312 0 0 1 1.47 1.291c-.603.361-1.101.865-1.45 1.464a4.013 4.013 0 0 0-.546 1.966c.005.776.242 1.534.68 2.182A4.081 4.081 0 0 0 33 22.243a9.874 9.874 0 0 1-1.269 2.544c-.77 1.086-1.592 2.168-2.83 2.19-.605.01-1.008-.158-1.426-.333-.436-.183-.889-.372-1.605-.372-.742 0-1.201.19-1.65.377-.399.167-.79.33-1.364.35-1.22.044-2.148-1.174-2.92-2.277-1.6-2.234-2.785-6.303-1.152-9.049a4.427 4.427 0 0 1 1.595-1.62 4.565 4.565 0 0 1 2.208-.635c.68-.012 1.33.24 1.9.46.432.166.818.315 1.132.315.284 0 .655-.142 1.093-.31Z",
    fill: "#102B3F"
  })));
};

export default SvgApplePay;